import React, { Suspense } from 'react';
import { Route } from 'react-router';
import { workflowDefinitionsSettings } from '../constants/constants';
import GenericSettingContainer from '../containers/GenericSettingContainer/GenericSettingContainer';
import PageLoader from '../components/PageLoader/PageLoader';

const WorkflowDefinitionsSettingsPage = React.lazy(
    () => import('../pages/WorkflowSettingsPages/WorkflowDefinitionsSettingsPage'),
);

const WorkflowSettingsRoutes = props => (
    <GenericSettingContainer {...props}>
        <Suspense fallback={<PageLoader />}>
            <Route path={workflowDefinitionsSettings} exact component={WorkflowDefinitionsSettingsPage} />
        </Suspense>
    </GenericSettingContainer>
);

export default WorkflowSettingsRoutes;
